import local from "./local";
const app = local("application_global", {
    inst: {
        name: "vortex",
        version: "0.0.1",
        isFocused: true,
        window: null,
        platform: "fallback",
        platformVersion: "1.0.0",
        memory: {
            total: 0,
        },
        quit: (code) => process["exit"](code),
    },
});
export function setApplication(appIn) {
    app.inst = appIn;
}
export function getApplication() {
    return app.inst;
}
const proxy = new Proxy(app, {
    get: (target, key, receiver) => Reflect.get(target.inst, key, receiver),
    set: () => {
        throw new Error("attempt to change read-only object");
    },
    deleteProperty: () => {
        throw new Error("attempt to change read-only object");
    },
});
/** @deprecated Use ApplicationData directly */
export default proxy;
